module.exports = __webpack_public_path__ + "static/blog-17-6915de3b368c888e45096afa2928c6af.png";